import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@app/core/auth.service';
import { OptInStatus } from '@app/core/model/qualifications.model';
import { IBonusQualificationService } from '@app/core/services/interface/IBonusQualificationService';

import { IConfigurationService } from '@app/core/services/interface/IConfigurationService';
import { ServiceFactory } from '@app/core/services/service.factory';
import { WigStatsComponent } from '@app/wig-stats/wig-stats.component';

@Component({
  selector: 'app-wig-tabs',
  templateUrl: './wig-tabs.component.html',
  styleUrls: ['./wig-tabs.component.css'],
})
export class WigTabsComponent implements OnInit {
  @ViewChild('wigStatsComponent') statTab: WigStatsComponent;
  bonusQualificationService: IBonusQualificationService;
  configurationService: IConfigurationService;
  @Input() driverType: string;
  enableBonusTabForDrivers: boolean;
  @Input() fleet: string;
  ignoreDriverTypes: string[];
  optInStatus: OptInStatus;
  tabIndex = 1;

  constructor(private authService: AuthService, serviceFactory: ServiceFactory) {
    this.bonusQualificationService = serviceFactory.getBonusQualificationService();
    this.configurationService = serviceFactory.getConfigurationService();
  }

  async refreshStats() {
    await this.statTab.loadDriverStats();
  }

  excludeBonus(): boolean {
    return (
      this.ignoreDriverTypes.some((value) => value === this.driverType) ||
      !this.isOptInStatusValid() ||
      this.enableBonusTabForDrivers === false
    );
  }

  isLoading(): boolean {
    return (
      this.optInStatus !== undefined &&
      this.fleet !== undefined &&
      this.ignoreDriverTypes !== undefined &&
      this.driverType !== undefined
    );
  }

  ngOnInit(): void {
    this.configurationService.getConfiguration().then((response) => {
      this.enableBonusTabForDrivers = response.enableBonusTabForDrivers;
      this.ignoreDriverTypes = response.ignoreDriverTypes;
    });
    this.loadOptInStatus();
  }

  onClick(tabIndex: number): void {
    this.tabIndex = tabIndex;
  }

  private loadOptInStatus(): void {
    this.bonusQualificationService
      .getOptInDetails(this.authService.getCurrentUser().username)
      .then((response) => {
        this.optInStatus = response;
      });
  }

  private isOptInStatusValid(): boolean {
    return (
      this.optInStatus &&
      this.optInStatus.status !== 'Excluded' &&
      this.optInStatus.status !== 'Invalid'
    );
  }
}
